import React from "react";
import { Link } from "react-router-dom";
//import "react-tooltip/dist/react-tooltip.css";

interface Props {
  PaintingId: string;
  PaintingName: string;
  Title: string;
  ThumbPath: string;
}

interface State {
  renderCount: number;
  isLoading: boolean;
}

class Print extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      renderCount: 0,
      isLoading: false,
    };
  }

  render() {
    let fullPath: string = this.props.ThumbPath + this.props.PaintingName;
    return (
      <div className="col-md-4">
        <div className="card card-product card-plain">
          <div className="card-image">
            <Link
              id={"painting_" + this.props.PaintingId}
              to={`../availableprintdetails/` + this.props.PaintingId}
            >
              <img
                src={fullPath}
                alt=""
                className="img-rounded img-responsive"
              />
            </Link>

            <div className="card-body">
              <div className="card-description">
                <Link
                  id={"painting_" + this.props.PaintingId}
                  to={`../availableprintdetails/` + this.props.PaintingId}
                >
                  <h5 className="card-title">{this.props.Title}</h5>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
